var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 506,
    height: 651,
    viewBox: "0 0 506 651",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3636_51780)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    transform: "matrix(0.761166 -0.648557 0.647587 0.761991 -121.596 231.481)",
    fill: "url(#paint0_linear_3636_51780)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-119.564 169.824L-90.025 204.581L-28.915 212.439L-58.4543 177.681L-119.564 169.824ZM-90.025 204.581L-92.0563 266.239L-62.517 300.997L-60.4857 239.339L-90.025 204.581ZM-1.40701 308.855L28.1323 343.613L89.2423 351.471L59.703 316.713L-1.40701 308.855Z",
    fill: "url(#paint1_linear_3636_51780)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-60.4857 239.339L0.62428 247.197L30.1636 281.955L-30.9464 274.097L-60.4857 239.339ZM-30.9464 274.097L-32.9777 335.755L-3.4384 370.513L-1.40706 308.855L-30.9464 274.097Z",
    fill: "#EBF5FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3636_51780)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    transform: "matrix(0.761153 -0.648573 0.647574 0.762003 -58.05 178.16)",
    fill: "url(#paint2_linear_3636_51780)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.0188 116.501L-26.4801 151.26L34.6287 159.117L5.09003 124.359L-56.0188 116.501ZM-26.4801 151.26L-28.5114 212.919L1.02727 247.677L3.05865 186.018L-26.4801 151.26ZM62.1361 255.535L91.6748 290.293L152.784 298.151L123.245 263.392L62.1361 255.535Z",
    fill: "url(#paint3_linear_3636_51780)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05886 186.018L64.1677 193.875L93.7064 228.634L32.5976 220.776L3.05886 186.018ZM32.5976 220.776L30.5662 282.435L60.1049 317.193L62.1363 255.534L32.5976 220.776Z",
    fill: "#EBF5FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3636_51780)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    transform: "matrix(0.761153 -0.648573 0.647574 0.762003 5.49536 124.839)",
    fill: "url(#paint4_linear_3636_51780)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52664 63.1804L37.0653 97.9387L98.1742 105.796L68.6354 71.0381L7.52664 63.1804ZM37.0653 97.9387L35.034 159.598L64.5727 194.356L66.6041 132.697L37.0653 97.9387ZM125.681 202.214L155.22 236.972L216.329 244.83L186.79 210.071L125.681 202.214Z",
    fill: "url(#paint5_linear_3636_51780)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6043 132.697L127.713 140.555L157.252 175.313L96.143 167.455L66.6043 132.697ZM96.143 167.455L94.1116 229.114L123.65 263.873L125.682 202.214L96.143 167.455Z",
    fill: "#EBF5FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3636_51780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.28211 309.595L27.2572 344.353L88.3672 352.211L58.8279 317.453L-2.28211 309.595ZM27.2572 344.353L25.2259 406.011L54.7652 440.769L56.7966 379.111L27.2572 344.353ZM115.875 448.626L145.415 483.384L206.525 491.242L176.985 456.484L115.875 448.626Z",
    fill: "#99CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7965 379.111L117.907 386.969L147.446 421.726L86.3358 413.869L56.7965 379.111ZM86.3358 413.869L84.3045 475.526L113.844 510.284L115.875 448.626L86.3358 413.869Z",
    fill: "#EBF5FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_3636_51780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.2632 256.273L90.8019 291.031L151.911 298.889L122.372 264.13L61.2632 256.273ZM90.8019 291.031L88.7705 352.69L118.309 387.448L120.341 325.789L90.8019 291.031ZM179.418 395.306L208.957 430.064L270.066 437.922L240.527 403.164L179.418 395.306Z",
    fill: "#99CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.341 325.789L181.45 333.647L210.988 368.405L149.88 360.548L120.341 325.789ZM149.88 360.548L147.848 422.207L177.387 456.965L179.418 395.306L149.88 360.548Z",
    fill: "#EBF5FF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_3636_51780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.808 202.951L154.347 237.71L215.456 245.567L185.917 210.809L124.808 202.951ZM154.347 237.71L152.316 299.369L181.854 334.127L183.886 272.468L154.347 237.71ZM242.963 341.985L272.502 376.743L333.611 384.601L304.072 349.842L242.963 341.985Z",
    fill: "#99CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.886 272.468L244.995 280.326L274.534 315.084L213.425 307.226L183.886 272.468ZM213.425 307.226L211.393 368.885L240.932 403.644L242.963 341.985L213.425 307.226Z",
    fill: "#EBF5FF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_3636_51780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115 449.367L144.539 484.124L205.649 491.982L176.11 457.224L115 449.367ZM144.539 484.124L142.508 545.782L172.047 580.54L174.078 518.882L144.539 484.124ZM233.157 588.398L262.696 623.156L323.806 631.014L294.267 596.256L233.157 588.398Z",
    fill: "#99CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.078 518.882L235.188 526.74L264.728 561.498L203.618 553.64L174.078 518.882ZM203.618 553.64L201.586 615.298L231.126 650.056L233.157 588.398L203.618 553.64Z",
    fill: "#EBF5FF"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_3636_51780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.545 396.044L208.084 430.802L269.193 438.66L239.654 403.901L178.545 396.044ZM208.084 430.802L206.053 492.461L235.591 527.219L237.623 465.56L208.084 430.802ZM296.7 535.077L326.239 569.835L387.348 577.693L357.809 542.935L296.7 535.077Z",
    fill: "#99CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.623 465.56L298.732 473.418L328.271 508.176L267.162 500.319L237.623 465.56ZM267.162 500.319L265.13 561.978L294.669 596.736L296.7 535.077L267.162 500.319Z",
    fill: "#EBF5FF"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_3636_51780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.091 342.723L271.63 377.481L332.738 385.339L303.2 350.581L242.091 342.723ZM271.63 377.481L269.598 439.14L299.137 473.899L301.168 412.24L271.63 377.481ZM360.246 481.756L389.784 516.515L450.893 524.372L421.355 489.614L360.246 481.756Z",
    fill: "#99CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.168 412.239L362.277 420.097L391.816 454.856L330.707 446.998L301.168 412.239ZM330.707 446.998L328.676 508.657L358.215 543.415L360.246 481.756L330.707 446.998Z",
    fill: "#EBF5FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246 226.92L307.109 236.287L336.648 277.722L275.539 268.355L246 226.92Z",
    fill: "#EBF5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.247 62.7167L180.698 130.186L195.397 181.662L219.945 114.193L205.247 62.7167Z",
    fill: "#EBF5FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3636_51780",
    x1: 41.9341,
    y1: -11.2451,
    x2: 41.4349,
    y2: 45.2594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3636_51780",
    x1: -119.564,
    y1: 169.824,
    x2: 57.9368,
    y2: 378.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#99CAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#99CAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3636_51780",
    x1: 41.9341,
    y1: -11.2451,
    x2: 41.4349,
    y2: 45.2594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3636_51780",
    x1: -56.0188,
    y1: 116.501,
    x2: 121.487,
    y2: 324.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#99CAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#99CAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3636_51780",
    x1: 41.9341,
    y1: -11.2451,
    x2: 41.4349,
    y2: 45.2594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3636_51780",
    x1: 7.52663,
    y1: 63.1804,
    x2: 185.032,
    y2: 271.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#99CAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#99CAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3636_51780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.761166 -0.648557 0.647587 0.761991 -121.596 231.481)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3636_51780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.761153 -0.648573 0.647574 0.762003 -58.05 178.16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3636_51780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.761153 -0.648573 0.647574 0.762003 5.49536 124.839)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3636_51780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.761166 -0.648557 0.647587 0.761991 -4.31348 371.253)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3636_51780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.761153 -0.648573 0.647574 0.762003 59.2319 317.932)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_3636_51780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.761153 -0.648573 0.647574 0.762003 122.777 264.61)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_3636_51780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.761166 -0.648557 0.647587 0.761991 112.968 511.024)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_3636_51780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.761153 -0.648573 0.647574 0.762003 176.514 457.703)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_3636_51780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.9534,
    height: 182.458,
    fill: "white",
    transform: "matrix(0.761153 -0.648573 0.647574 0.762003 240.06 404.382)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternLeft);
export default __webpack_public_path__ + "static/media/pattern-left.3104cebb39b4ab694b50449b19682595.svg";
export { ForwardRef as ReactComponent };